import { ref } from 'vue'

export const assetRefreshCallback = ref<Function[]>()
export const dataAssetRefreshCallback = ref<Function[]>()
